export default __webpack_public_path__ + "static/media/my_ua.b11959e1.svg";